module.exports = __webpack_public_path__ + "static/media/icon-motora-connect-blue.8ad6139e.png";